/* Voltage — botón "+ Añadir 1 bote" del aviso de packs en el carrito lateral */
(function () {
  if (window.__mtCart) return;
  window.__mtCart = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mt-nudge__add');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variant), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) throw new Error(j.description || 'Error');
        var EV = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
        if (typeof window.publish === 'function' && EV) window.publish(EV.cartUpdate, { source: 'mt-nudge', cartData: j });
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(j);
        else window.location.reload();
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  });
})();
